// extracted by mini-css-extract-plugin
export default {"home":"c-c_ee","home__content":"c-c_ef"};